import { render, staticRenderFns } from "./chirp-conversation-question.vue?vue&type=template&id=0cf06048&scoped=true&"
import script from "./chirp-conversation-question.vue?vue&type=script&lang=js&"
export * from "./chirp-conversation-question.vue?vue&type=script&lang=js&"
import style0 from "./chirp-conversation-question.vue?vue&type=style&index=0&id=0cf06048&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf06048",
  null
  
)

export default component.exports